export default __webpack_public_path__ + "static/media/future.da16c4c2.svg";